import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link } from 'react-router-dom';
import MusicPlayer from './components/MusicPlayer';
import Banner from './components/Banner';
import Home from './pages/Home';
import Profile from './pages/Profile';
import Gallery from './pages/Gallery';
import Trpg from './pages/Trpg';
import Memo from './pages/Memo';

function App() {
  return (
    <Router>
      <div className='w-screen h-screen flex items-center justify-around'>
        <div className='w-[90%] h-[90%] flex items-center justify-between gap-[5%]'>
          {/* 왼쪽 메뉴 */}
          <div className='w-[20%] h-full'>
            <div className='w-full bg-white border border-black rounded-lg'>
              <MusicPlayer />
            </div>
            <div className='w-full h-[70%] flex flex-col gap-2 pt-10'>
              <Banner href="https://ctal-11cea.web.app/" imgSrc="/assets/ctal-banner.jpg" />
              <Banner imgSrc="/assets/banner.png" />
              <Banner imgSrc="/assets/banner.png" />
              <Banner imgSrc="/assets/banner.png" />
            </div>
          </div>

          {/* 중앙 콘텐츠 */}
          <div className="w-full h-full flex flex-col items-center">
            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/profile" element={<Profile />} />
              <Route path="/gallery" element={<Gallery />} />
              <Route path="/trpg" element={<Trpg />} />
              <Route path="/memo" element={<Memo />} />
            </Routes>
          </div>

          {/* 오른쪽 메뉴 */}
          <div className='w-[20%] h-full'>
            <div className='w-full h-[73%] text-blue-500 bg-white gap-[1%] flex flex-col items-start border border-gray-300 rounded-lg'>
              <div className='self-center font-normal pt-5 pb-5 font-mochiy' style={{ fontSize: '2vw' }}>
                MENU
              </div>
              <div className="flex flex-col items-start gap-2 px-4">
                <Link to="/" className='text-blue-500'>Home</Link>
                <Link to="/profile" className='text-blue-500'>Profile</Link>
                <Link to="/gallery" className='text-blue-500'>Gallery</Link>
                <Link to="/trpg" className='text-blue-500'>Trpg</Link>
                <Link to="/Memo" className='text-blue-500'>Memo</Link>
              </div>
            </div>
          </div>
        </div>

        {/* 데코 */}
        <img className='absolute left-[3%] top-[3%] z-50' style={{ width: '5vw' }} src="/assets/deco-star/star-1.png" alt="데코 이미지" />
        <img className='absolute left-[20%] top-[24%] z-50' style={{ width: '5vw' }} src="/assets/deco-star/star-2.png" alt="데코 이미지" />
        <img className='absolute right-[18%] bottom-[22%] z-50' style={{ width: '6vw' }} src="/assets/deco-star/star-3.png" alt="데코 이미지" />
        <img className='absolute left-[16%] bottom-[7%] z-50' style={{ width: '8vw' }} src="/assets/deco-star/star-4.png" alt="데코 이미지" />
      </div>
    </Router>
  );
}

export default App;
